import { render, staticRenderFns } from "./ChallengeAddon.vue?vue&type=template&id=1a3a7f4f&scoped=true"
import script from "./ChallengeAddon.vue?vue&type=script&lang=js"
export * from "./ChallengeAddon.vue?vue&type=script&lang=js"
import style0 from "./ChallengeAddon.vue?vue&type=style&index=0&id=1a3a7f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a7f4f",
  null
  
)

export default component.exports